function flattenMessages(nestedMessages, prefix = '') {
  return Object.keys(nestedMessages).reduce((messages, key) => {
    let value = nestedMessages[key];
    let prefixedKey = prefix ? `${prefix}.${key}` : key;

    if (typeof value === 'string') {
      messages[prefixedKey] = value;
    } else {
      if (typeof Object.assign !== 'function') {
        return messages;
      } else {
        Object.assign(messages, flattenMessages(value, prefixedKey));
      }
    }
    return messages;
  }, {});
}

export { flattenMessages };
